/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFlag2Off = createReactComponent("flag-2-off", "IconFlag2Off", [
  ["path", { d: "M5 14h9m4 0h1v-9h-10m-4 0v16", key: "svg-0" }],
  ["path", { d: "M3 3l18 18", key: "svg-1" }]
]);

export { IconFlag2Off as default };
//# sourceMappingURL=IconFlag2Off.js.map
